import React, { useContext, useEffect, useReducer, useState } from "react";
import { Collapse } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { getMenuList } from "./Menu";
import { ThemeContext } from "../../../context/ThemeContext";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);

  const date = new Date();
  const [heartBtn, setHeartBtn] = useState(false);
  const [state, setState] = useReducer(reducer, initialState);

  const location = useLocation(); // ✅ IMPORTANT
  const MenuList = getMenuList(); // ✅ get dynamic menu

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };

  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };

  // For scroll
  const [hideOnScroll, setHideOnScroll] = useState(true);

  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll]
  );

  // ✅ CURRENT PATH
  let path = location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  // ✅ AUTO ACTIVE MENU ON ROUTE CHANGE
  useEffect(() => {
    MenuList.forEach((data) => {
      if (data.to === path) {
        setState({ active: data.title });
      }

      data.content?.forEach((item) => {
        if (path === item.to) {
          setState({ active: data.title });
        }

        item.content?.forEach((ele) => {
          if (path === ele.to) {
            setState({
              activeSubmenu: item.title,
              active: data.title,
            });
          }
        });
      });
    });
  }, [location.pathname]); // ✅ IMPORTANT

  return (
    <div
      onMouseEnter={() => ChangeIconSidebar(true)}
      onMouseLeave={() => ChangeIconSidebar(false)}
      className={`deznav ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
      <div className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {MenuList.map((data, index) => {
            let menuClass = data.classsChange;

            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              return (
                <li
                  className={`has-menu ${
                    state.active === data.title ? "mm-active" : ""
                  } ${data.to === path ? "mm-active" : ""}`}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow ai-icon"
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}{" "}
                        <span className="nav-text">
                          {data.title}
                          <span className="badge badge-xs style-1 badge-danger ms-2">
                            {data.update}
                          </span>
                        </span>
                      </Link>

                      <Collapse in={state.active === data.title ? true : false}>
                        <ul
                          className={`${
                            menuClass === "mm-collapse" ? "mm-show" : ""
                          }`}
                        >
                          {data.content &&
                            data.content.map((item, index) => {
                              return (
                                <li
                                  key={index}
                                  className={`${
                                    state.activeSubmenu === item.title
                                      ? "mm-active"
                                      : ""
                                  } ${item.to === path ? "mm-active" : ""}`}
                                >
                                  {item.content && item.content.length > 0 ? (
                                    <>
                                      <Link
                                        to={item.to}
                                        className={item.hasMenu ? "has-arrow" : ""}
                                        onClick={() => {
                                          handleSubmenuActive(item.title);
                                        }}
                                      >
                                        {item.title}
                                      </Link>

                                      <Collapse
                                        in={
                                          state.activeSubmenu === item.title
                                            ? true
                                            : false
                                        }
                                      >
                                        <ul
                                          className={`${
                                            menuClass === "mm-collapse"
                                              ? "mm-show"
                                              : ""
                                          }`}
                                        >
                                          {item.content &&
                                            item.content.map((subItem, index) => {
                                              return (
                                                <li key={index}>
                                                  <Link
                                                    className={`${
                                                      path === subItem.to
                                                        ? "mm-active"
                                                        : ""
                                                    }`}
                                                    to={subItem.to}
                                                  >
                                                    {subItem.title}
                                                  </Link>
                                                </li>
                                              );
                                            })}
                                        </ul>
                                      </Collapse>
                                    </>
                                  ) : (
                                    <Link
                                      to={item.to}
                                      className={`${
                                        item.to === path ? "mm-active" : ""
                                      }`}
                                    >
                                      {item.title}
                                    </Link>
                                  )}
                                </li>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link
                      to={data.to}
                      className={`${data.to === path ? "mm-active" : ""}`}
                    >
                      {data.iconStyle}{" "}
                      <span className="nav-text">
                        {data.title}
                        <span className="badge badge-xs style-1 badge-danger ms-2">
                          {data.update}
                        </span>
                      </span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
      </div>
    </div>
  );
};

export default SideBar;